export default __webpack_public_path__ + "img/Poppins-ExtraLight_f1a924d.eot";